<template>
  <div>
    <el-upload
      class="upload-demo"
      action="/api/excel/importDb"
      :headers="upheader"
      :on-success="upsuccess">
      <el-button size="small" type="primary">点击上传</el-button>
      <span style="font-size: 12px;color: red;">只能上传xlsx文件</span>
    </el-upload>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-input size="small" v-model="formInline.hzxm" placeholder="输入姓名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.sfzh" placeholder="输入身份证号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-refresh-left" @click="formReset()">重置</el-button>
      </el-form-item>
      <el-form-item style="float: right;">
        <el-button type="danger" size="small" @click="deljhs()">删除</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table ref="multipleTable" @selection-change="handleSelectionChange" size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column align="center" prop="hzxm" label="患者姓名" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="sfzh" label="身份证" width="160" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="jyxm" label="检验项目" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="sjsj" label="送检时间" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="bgsj" label="报告时间" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="bgr" label="报告人" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="jyjg" label="检验结果" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="jydd" label="检验地点" width="120" show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import { hsjglist,delHsjg } from '../../api/baseset'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        formInline: {
          page: 1,
          limit: 10
        },
        listData: [],
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        fileList: [],
        upheader: {
          token: localStorage.getItem('logintoken')
        },
        multipleSelection: [],
        ids: ''
      };
    },
    components:{
      Pagination
    },
    created() {
      this.getdata(this.formInline)
    },
    methods: {
      getdata(param){
        this.loading = true
        hsjglist(param).then(res => {
          this.loading = false
          if(res.code == 0){
            this.listData = res.data.list
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.count
          }
        }).catch(err => {
           this.loading = false
           this.$message.error('数据加载失败，请稍后再试！')
         })
      },
      upsuccess(res) {
        if(res.code == 0){
          this.getdata(this.formInline)
          this.$message({
            type: 'success',
            message: res.msg
          })
        }else{
          this.$message.error(res.msg)
        }
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.page = 1
        this.formInline.limit = 10
        this.getdata(this.formInline)
      },
      // 重置搜索
      formReset() {
         this.formInline = {
           page: 1,
           limit: 10
         }
      },
      handleSelectionChange(arr) {
        this.multipleSelection = arr;
        let str = '';
        arr.forEach(function(v){
          str += v.id+','
        })
        this.ids = str.substr(0,str.length-1);
      },
      deljhs() {
        this.$confirm('您确定要删除此信息吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          let data = {ids:this.ids}
          delHsjg(data).then(res => {
            this.loading = false
            if(res.code == 0){
              this.getdata(this.formInline)
              this.$message({
                type: 'success',
                message: res.msg
              })
            }else{
              this.$message.error(res.msg)
            }
          }).catch(err => {
            this.loading = false
            this.$message.error('数据加载失败，请稍后再试！')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    }
  }
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/hsjc/hssb.vue